
// Save utm to session storage for future tracking
export function saveUtmTracking(query) {
  if (query['utm_source'] || query['utm_medium'] || query['utm_campaign']) {
    sessionStorage.setItem('BC_utm_source', JSON.stringify({
      utm_source : query['utm_source'],
      utm_medium: query['utm_medium'],
      utm_campaign: query['utm_campaign'],
    }));
  } else if (query['gclid']) {
    sessionStorage.setItem('BC_utm_source', JSON.stringify({
      utm_source : "google",
      utm_medium: "cpc",
    }));
  }
}

// Get last utm source
export function getUtmSource() {
  const st = sessionStorage.getItem('BC_utm_source')
  if (!st) {
    return 'organic';
  }
  const utm_source = JSON.parse(st)['utm_source']
  if (!utm_source) {
    return 'none';
  }
  return utm_source;
}